// S2-FE2: ActionCard
import './ActionCard.css';
import { Badge } from './Badge';

export interface ActionCardProps {
  actionType: 'content_tune' | 'knob_addition' | 'parameter_change';
  knobId: string;
  title: string;
  description: string;
  severity: 'high' | 'medium' | 'low';
}

// Map severity to Badge variant
const severityBadgeMap: Record<string, 'error' | 'warning' | 'info'> = {
  high: 'error',
  medium: 'warning',
  low: 'info',
};

// Readable label for action type
const actionTypeLabel: Record<string, string> = {
  content_tune: 'Content Tune',
  knob_addition: 'Knob Addition',
  parameter_change: 'Param Change',
};

export function ActionCard({ actionType, knobId, title, description, severity }: ActionCardProps) {
  return (
    <div className={`airgent-action airgent-action-${severity}`}>
      <div className="airgent-action-header">
        <Badge variant={severityBadgeMap[severity]} size="sm">
          {actionTypeLabel[actionType]}
        </Badge>
        <span className="airgent-action-knob">{knobId}</span>
      </div>
      <div className="airgent-action-title">{title}</div>
      <div className="airgent-action-description">{description}</div>
    </div>
  );
}
